import { render, staticRenderFns } from "./helpFriend.vue?vue&type=template&id=50b0bf1e&scoped=true"
import script from "./helpFriend.vue?vue&type=script&lang=js"
export * from "./helpFriend.vue?vue&type=script&lang=js"
import style0 from "./helpFriend.vue?vue&type=style&index=0&id=50b0bf1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b0bf1e",
  null
  
)

export default component.exports